exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page {\n  box-sizing: content-box;\n  max-width: 100%; }\n\n@media (min-width: 348px) {\n  .page {\n    max-width: 300px; } }\n\n@media (min-width: 503px) {\n  .page {\n    max-width: 455px; } }\n\n@media (min-width: 658px) {\n  .page {\n    max-width: 610px; } }\n\n@media (min-width: 819px) {\n  .page {\n    max-width: 765px; } }\n\n@media (min-width: 974px) {\n  .page {\n    max-width: 920px; } }\n\n@media (min-width: 1290px) {\n  .page {\n    max-width: 1230px; } }\n\nnav {\n  margin-bottom: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/admin/admin.component.scss
// module id = ../../../../../src/app/admin/admin.component.scss
// module chunks = main